import { render, staticRenderFns } from "./dict-detail.vue?vue&type=template&id=055f482c&scoped=true&"
import script from "./dict-detail.vue?vue&type=script&lang=ts&"
export * from "./dict-detail.vue?vue&type=script&lang=ts&"
import style0 from "./dict-detail.vue?vue&type=style&index=0&id=055f482c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f482c",
  null
  
)

export default component.exports